import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { SxProps, Theme } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';
interface Props {
  sx?: SxProps<Theme>;
  children?: ReactNode;
}
const LearningStatus = t0 => {
  const $ = _c(7);
  const {
    sx: t1,
    children
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sx = t2;
  let t3;
  if ($[2] !== sx) {
    t3 = {
      borderRadius: "50%",
      height: 24,
      width: 24,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid",
      ...sx
    };
    $[2] = sx;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <Box sx={t3}>{children}</Box>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default LearningStatus;